import styled from 'styled-components';
import { AppLink } from '@finect/tabular-core/AppLink';
export var IntroBlock = styled.div.withConfig({
  displayName: "partials__IntroBlock",
  componentId: "sc-1sq0nrw-0"
})(["display:flex;padding:24px 2px 0 24px;margin-bottom:0;"]);
export var AnswersBlock = styled.div.withConfig({
  displayName: "partials__AnswersBlock",
  componentId: "sc-1sq0nrw-1"
})(["margin:24px 0 0;"]);
export var FooterBlock = styled.div.withConfig({
  displayName: "partials__FooterBlock",
  componentId: "sc-1sq0nrw-2"
})(["margin-top:18px;"]);
export var MoreAuthorsBlock = styled.div.withConfig({
  displayName: "partials__MoreAuthorsBlock",
  componentId: "sc-1sq0nrw-3"
})(["display:flex;align-items:center;padding:12px 9px;border-radius:", ";box-shadow:0 1px 2px ", ";background-color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.borderRadius;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.ui;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.uiLL;
});
export var IconsBlock = styled.div.withConfig({
  displayName: "partials__IconsBlock",
  componentId: "sc-1sq0nrw-4"
})(["display:flex;margin-right:6px;"]);
export var Title = styled(AppLink).withConfig({
  displayName: "partials__Title",
  componentId: "sc-1sq0nrw-5"
})(["font-size:18px;font-weight:700;line-height:27px;color:currentColor;&:hover{color:", ";text-decoration:underline;}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.linkColor;
});
export var ActionLine = styled.span.withConfig({
  displayName: "partials__ActionLine",
  componentId: "sc-1sq0nrw-6"
})(["margin-left:6px;"]);